// extracted by mini-css-extract-plugin
module.exports = {"summary":"post-comments-and-likes_summary__rPJao"};